
import { TypeOrmModule } from '@nestjs/typeorm';
import { forwardRef, Module } from '@nestjs/common';
import { WelfareStatusEntity } from './welfarestatus.entity';
import { WelfarestatusController } from './welfarestatus.controller';
import { WelfarestatusService } from './welfarestatus.service';
import { WelfareModule } from '../welfare/welfare.module';



@Module({
  imports: [
    TypeOrmModule.forFeature([WelfareStatusEntity]),
  ],
  controllers: [WelfarestatusController],
  providers: [WelfarestatusService],
  exports:[WelfarestatusService]
})
export class WelfarestatusModule {}